import React from 'react'
import ReactDOM from 'react-dom/client'
import { App, useQuestionizerStore } from 'questionizer-core'
import './index.scss'

// Modernisierung (id:10) → Altbau, Neubau (id:20) → Neubau
const GROUP_TYP_MAP: Record<number, string> = {
  10: 'Altbau',
  20: 'Neubau',
};

// Gewerke pro Gruppe – beim Gruppenwechsel werden die jeweils anderen deaktiviert
const GROUP_GEWERKE: Record<number, number[]> = {
  10: [1010, 1020, 1030, 1040, 1050, 1060, 1070, 1080, 1090, 1100, 1101, 1102],
  20: [201, 202],
};

useQuestionizerStore.subscribe((state, prevState) => {
  for (const [idStr, forcedTyp] of Object.entries(GROUP_TYP_MAP)) {
    const id = Number(idStr);
    const wurdeAktiviert = state.active_groups[id] && !prevState.active_groups[id];
    if (wurdeAktiviert) {
      state.setTyp(forcedTyp);
      state.setBaujahr(id === 20 ? new Date().getFullYear() : undefined);
      // andere Gruppen + deren Gewerke aus Auswahl entfernen
      const otherIds = Object.keys(GROUP_TYP_MAP).map(Number).filter(k => k !== id);
      const patchedGroups = { ...state.active_groups };
      otherIds.forEach(otherId => {
        patchedGroups[otherId] = false;
        GROUP_GEWERKE[otherId]?.forEach(gid => state.toggleGewerk(gid, false));
      });
      useQuestionizerStore.setState({ active_groups: patchedGroups });
      break;
    }
  }
});

let configPath = document!.querySelector('meta[name="febis-questionizer-config-url"]')?.getAttribute('content');
if (configPath !== undefined) {
    ReactDOM.createRoot(document.getElementById('febis-questionizer')!).render(
    <React.StrictMode>
      <App configPath={configPath}/>
    </React.StrictMode>);
  }else{
    console.warn("Keine Konfiguration gefunden");
  }